import React, { useEffect, useState } from 'react';
import { BdsGrid } from 'blip-ds/dist/blip-ds-react';
import CreateCertificate from './Components/CreateCertificate';
import ListCertificates from './Components/ListCertificates';
import MtlsContext from '../../contexts/MtlsContext';
import MtlsCertificateApi from '../../api/MtlsCertificateApi';
import { useTenant } from '../../contexts/TenantContext';
import { MtlsCertificate } from '../../models/MtlsCertificate';
import { localization } from './localization';
import { useCommon } from '../../contexts/CommonContext';
import { useContentLocalizer } from '../../hooks/useContentLocalizer';
import { CertificateInputs } from '../../interfaces';
import './styles.scss';

interface CertificateUpdatedProps {
  certificateId: string;
  certificateUpdated: boolean;
  hostId: string;
  hostUpdated: boolean;
}

const Mtls: React.FC = () => {
  const { tenant } = useTenant();
  const tenantId = tenant.info.id;
  const { setHeaderContent } = useCommon();
  const content = useContentLocalizer(localization);
  const mtlsCertificateApi = new MtlsCertificateApi();
  const [mtlsCertificate, setMtlsCertificate] = useState<MtlsCertificate[]>();
  const [removeCertificateAlert, setRemoveCertificateAlert] = useState(false);
  const [removeHostAlert, setRemoveHostAlert] = useState(false);
  const [certificateUpdatedProps, setCertificateUpdatedProps] = useState<CertificateUpdatedProps>({
    certificateId: '',
    certificateUpdated: false,
    hostId: '',
    hostUpdated: false,
  });

  const emptyCertificate: CertificateInputs = {
    file: new Blob(),
    fileName: '',
    password: '',
    description: '',
    hosts: [{ host: '', validUrl: true }],
  };
  const [certificateInputs, setCertificateInputs] = useState<CertificateInputs>(emptyCertificate);

  const toggleSubmitModal = () => {
    const certificateModal = document.getElementById('certificate-modal');
    if (!certificateModal) return;

    certificateModal.toggle();
  };

  const toggleHostsModal = () => {
    const hostsModal = document.getElementById('hosts-modal');
    if (!hostsModal) return;

    hostsModal.toggle();
  };

  const openRemoveCertificateAlert = () => setRemoveCertificateAlert(true);
  const closeRemoveCertificateAlert = () => setRemoveCertificateAlert(false);

  const openRemoveHostAlert = () => setRemoveHostAlert(true);
  const closeRemoveHostAlert = () => setRemoveHostAlert(false);

  useEffect(() => {
    setHeaderContent({
      redirect: '/',
      text: content.formatString(content.header, tenant.info.name),
    });
    return () => setHeaderContent({ redirect: '/' });
  }, []);

  const contextProps = React.useMemo(
    () => ({
      toggleSubmitModal,
      toggleHostsModal,
      removeCertificateAlert,
      removeHostAlert,
      openRemoveCertificateAlert,
      closeRemoveCertificateAlert,
      openRemoveHostAlert,
      closeRemoveHostAlert,
      mtlsCertificateApi,
      tenantId,
      mtlsCertificate,
      setMtlsCertificate,
      content,
      certificateUpdatedProps,
      setCertificateUpdatedProps,
      emptyCertificate,
      certificateInputs,
      setCertificateInputs,
    }),
    [removeCertificateAlert, removeHostAlert, mtlsCertificate, certificateUpdatedProps, certificateInputs],
  );

  return (
    <MtlsContext.Provider value={contextProps}>
      <BdsGrid containerFluid id="certificates" margin="y-5" direction="column" gap="2">
        <CreateCertificate />
        <ListCertificates />
      </BdsGrid>
    </MtlsContext.Provider>
  );
};

export default Mtls;
